import useGetApi from 'src/api/useGetApi';

interface WorkOSResponse {
  authorizationUrl: string | null;
}

export const useWorkOSUrl = () => {
  return useGetApi<WorkOSResponse>({
    endpoint: 'auth/workos',
  });
};
